/* eslint-disable */
export enum FinnairCabinClass {
  ECONOMY = 'ECONOMY',
  ECOPREMIUM = 'ECOPREMIUM',
  BUSINESS = 'BUSINESS',
  FIRST = 'FIRST'
}

